// import { Client, Account,  OAuthProvider } from 'appwrite';

// const client = new Client();

// client
//     .setEndpoint('https://cloud.appwrite.io/v1')
//     .setProject('67e9019c003dd8fd498f');

// export const account = new Account(client);

// // Google OAuth-ით შესვლის ფუნქცია
// export const loginWithGoogle = () => {
//     // ვიყენებთ მიმდინარე საიტის URL-ს როგორც redirect URL
//     const redirectUrl = window.location.origin;
    
//     // ვქმნით OAuth სესიას
//     account.createOAuth2Session(OAuthProvider.Google, redirectUrl);
// };

// // მიმდინარე სესიის შემოწმება და მომხმარებლის მონაცემების მიღება
// export const getCurrentUser = async () => {
//     try {
//         // ვიღებთ მიმდინარე აუთენტიფიცირებული მომხმარებლის მონაცემებს
//         const user = await account.get();

//         // console.log("AppWrite: Retrieved user from Appwrite:", user);
        
//         // ვამზადებთ მომხმარებლის მონაცემებს Root.tsx-ის თავსებადი ფორმატით
//         const userData = {
//           external_Id: user.$id,
//           full_name: user.name,
//           email: user.email,
//           first_name: user.name?.split(' ')[0] || '',
//           // Google-ის პროფილის სურათის URL მიღება
//           profile_img: user.prefs?.avatar || user.prefs?.profilePicture || 
//                       "https://xeloba.ge/static/media/client_images/default_profile.png",
//           user_type: "clientOfGoogle"
//       };
        
//         // console.log("AppWrite: Formatted user data:", userData);
        
//         // ვინახავთ მომხმარებლის მონაცემებს localStorage-ში
//         localStorage.setItem("user", JSON.stringify({
//             external_Id: userData.external_Id,
//             first_name: userData.first_name,
//             profile_img: userData.profile_img,
//             user_type: userData.user_type,
//             email: userData.email
//         }));
        
        
//         // ვამოწმებთ რომ შენახვა მოხდა წარმატებით
//         const storedUser = localStorage.getItem("user");
//         // console.log("AppWrite: Verified localStorage user:", storedUser);
        
//         return userData;
//     } catch (error) {
//         // console.error("AppWrite: Error getting user:", error);
//         return null;
//     }
// };

// // გამოსვლის ფუნქცია
// export const logout = async () => {
//     try {
//         // ვშლით მიმდინარე სესიას
//         await account.deleteSession('current');
        
//         // ვშლით მომხმარებლის მონაცემებს localStorage-დან
//         localStorage.removeItem("user");
        
//         // ვაბრუნებთ წარმატების სტატუსს
//         return true;
//     } catch (error) {
//         console.error("AppWrite: Error during logout:", error);
//         return false;
//     }
// };

// // გლობალური ფუნქცია localStorage-ის სტატუსის შესამოწმებლად
// export const checkLocalStorage = () => {
//     const user = localStorage.getItem("user");
//     console.log("AppWrite: Current localStorage user:", user);
//     return user ? JSON.parse(user) : null;
// };



/////////////////////////// appwrite.ts 
import { Client, Account, OAuthProvider } from 'appwrite';

const client = new Client();

client
    .setEndpoint('https://cloud.appwrite.io/v1')
    .setProject('67e9019c003dd8fd498f');

export const account = new Account(client);

// Google OAuth-ით შესვლის ფუნქცია, ვიყენებთ createOAuth2Token მეთოდს
export const loginWithGoogle = () => {
    // ვიყენებთ მიმდინარე საიტის URL-ს როგორც redirect URL
    const redirectUrl = `${window.location.origin}/auth/callback`;
    const failureUrl = window.location.origin;
    
    // ვქმნით OAuth token-ს სესიის ნაცვლად
    account.createOAuth2Token(OAuthProvider.Google, redirectUrl, failureUrl);
};

// OAuth callback-ის დამმუშავებელი ფუნქცია
export const handleOAuthCallback = async (urlParams:any) => {
    // ვკითხულობთ userId და secret პარამეტრებს URL-დან
    const userId = urlParams.get('userId');
    const secret = urlParams.get('secret');
    
    if (userId && secret) {
        try {
            // ვქმნით სესიას token-ით
            await account.createSession(userId, secret);
            return await getCurrentUser();
        } catch (error) {
            console.error("Error creating session:", error);
            return null;
        }
    }
    return null;
};

// მიმდინარე სესიის შემოწმება და მომხმარებლის მონაცემების მიღება
export const getCurrentUser = async () => {
    try {
        // ვიღებთ მიმდინარე აუთენტიფიცირებული მომხმარებლის მონაცემებს
        const user = await account.get();
        
        // ვამზადებთ მომხმარებლის მონაცემებს Root.tsx-ის თავსებადი ფორმატით
        const userData = {
          external_Id: user.$id,
          full_name: user.name,
          email: user.email,
          first_name: user.name?.split(' ')[0] || '',
          // Google-ის პროფილის სურათის URL მიღება
          profile_img: user.prefs?.avatar || user.prefs?.profilePicture || 
                      "https://xeloba.ge/static/media/client_images/default_profile.png",
          user_type: "clientOfGoogle"
        };
        
        // ვინახავთ მომხმარებლის მონაცემებს localStorage-ში
        localStorage.setItem("user", JSON.stringify({
            external_Id: userData.external_Id,
            first_name: userData.first_name,
            profile_img: userData.profile_img,
            user_type: userData.user_type,
            email: userData.email
        }));
        
        return userData;
    } catch (error) {
        // console.error("AppWrite: Error getting user:", error);
        return null;
    }
};

// გამოსვლის ფუნქცია
export const logout = async () => {
    try {
        // ვშლით მიმდინარე სესიას
        await account.deleteSession('current');
        
        // ვშლით მომხმარებლის მონაცემებს localStorage-დან
        localStorage.removeItem("user");
        
        // ვაბრუნებთ წარმატების სტატუსს
        return true;
    } catch (error) {
        console.error("AppWrite: Error during logout:", error);
        return false;
    }
};

// გლობალური ფუნქცია localStorage-ის სტატუსის შესამოწმებლად
export const checkLocalStorage = () => {
    const user = localStorage.getItem("user");
    // console.log("AppWrite: Current localStorage user:", user);
    return user ? JSON.parse(user) : null;
};